module.exports = __webpack_public_path__ + "./images/6c6ff60b8af85981f53444f991dedd97.webp";